import { render, staticRenderFns } from "./LandingPageNavbar.vue?vue&type=template&id=c05b3f4e&scoped=true&"
import script from "./LandingPageNavbar.vue?vue&type=script&lang=js&"
export * from "./LandingPageNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05b3f4e",
  null
  
)

export default component.exports